// react router dom
import { Link } from "react-router-dom";
// constants
import { WHITE_THEME } from "../../../constants/logo";
// assets
import whiteLogo from "../../../assets/icons/whiteLogo.svg";
import darkLogo from "../../../assets/icons/darkLogo.svg";

const Logo = (props) => {
  // porps
  const { classNames, theme } = props;

  return (
    <div className={classNames}>
      <Link to="/">
        <img
          src={theme === WHITE_THEME ? whiteLogo : darkLogo}
          alt="mtor"
          className="w-24"
        />
      </Link>
    </div>
  );
};

export default Logo;
